<simple-center-loader *ngIf="loading"></simple-center-loader>

<!--Profile not found-->
<not-found *ngIf="!profile && !loading"></not-found>

<div *ngIf="profile && !loading" class="flex-grow-1">
  <!-- Top Card With Creator Info -->
  <creator-profile-top-card
    *ngIf="profile && !loading"
    [profile]="profile"
    (userUnblocked)="unblockUser()"
    (userBlocked)="blockUser()"
  ></creator-profile-top-card>

  <!-- Feed Selector -->
  <tab-selector
    [tabs]="['Posts', 'Creator Coin', 'DAO Coin', 'Diamonds', 'NFTs']"
    [activeTab]="activeTab"
    (tabClick)="_handleTabClick($event)"
  ></tab-selector>

  <!-- Reserved -->
  <div *ngIf="showProfileAsReserved() && activeTab === 'Posts'" class="p-15px">
    <div
      class="background-color-grey p-35px br-12px d-flex flex-row align-items-center"
    >
      <i class="far fa-clock fs-1 fc-muted"></i>
      <div class="ml-25px fc-default">
        <p class="roboto-mono fs-18px mb-5px font-weight-semibold">
          This profile is reserved
        </p>
        <p class="roboto-mono fs-15px">
          @{{ profile.Username }} has not joined DeSo yet.
        </p>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-30px">
      <div>
        <p class="font-weight-semibold roboto-mono mb-10px">
          Are you @{{ profile.Username }} on Twitter? To claim this profile:
        </p>
        <ol>
          <li class="font-weight-semibold">
            <p
              class="roboto-mono mb-10px font-weight-semibold cursor-pointer"
              style="text-decoration: line-through"
              (click)="globalVars.launchSignupFlow()"
            >
              Create a brand new DeSo public key.
            </p>
          </li>
          <li class="font-weight-semibold">
            <p class="roboto-mono mb-10px font-weight-semibold">
              <a target="_blank" href="{{ tweetToClaimLink() }}">
                Tweet your DeSo public key and tag #deso.
              </a>
              <span class="d-block fs-12px font-weight-normal">
                Note: The public key you tweet will be swapped with the public
                key currently associated with this profile. This will also swap
                all creator coin holdings. Please make sure that the public key
                you tweet does not have any creator coins, if you do not want
                them to be lost.
              </span>
            </p>
          </li>
          <li class="font-weight-semibold">
            <p class="roboto-mono mb-10px font-weight-semibold">
              Your username will be transferred within 48 hours.
            </p>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <!-- Posts -->
  <div *ngIf="profile && activeTab == 'Posts' && !loading">
    <creator-profile-posts
      [profile]="profile"
      [showProfileAsReserved]="showProfileAsReserved()"
      (blockUser)="userBlocked()"
    ></creator-profile-posts>
    <div
      *ngIf="globalVars.hasUserBlockedCreator(profile.PublicKeyBase58Check)"
      class="w-100 d-flex p-15px"
    >
      <span>
        You have blocked {{ profile.Username }}.
        <a (click)="unblock()">Unblock</a>
        to see their posts.
      </span>
    </div>
  </div>

  <!-- Creator Coin Info -->
  <div
    class="w-100 d-flex flex-column"
    *ngIf="activeTab == 'Creator Coin' && !loading"
  >
    <div class="w-100 d-flex justify-content-start px-15px fs-15px">
      <div
        class="container border-bottom border-color-grey font-weight-bold fs-20px pl-0px py-15px"
      >
        Holders of ${{ profile.Username }}'s Creator Coin
      </div>
    </div>

    <div>
      <div class="container fs-15px flex-grow-1">
        <div class="row no-gutters border-bottom border-color-grey fc-muted">
          <div class="col-6 d-flex py-15px mb-0">Username or PubKey</div>
          <div class="col-3 py-15px mb-0">Coins Held</div>
          <div class="col-3 py-15px mb-0">
            Market Value
            <i
              class="fas fa-info-circle text-greyC fs-15px global__tooltip-icon"
              matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
              [matTooltip]="
                'This is computed as the number of coins times the current price.'
              "
              #tooltip="matTooltip"
              (click)="tooltip.toggle()"
            ></i>
          </div>
        </div>
        <creator-profile-hodlers [profile]="profile"></creator-profile-hodlers>
      </div>
    </div>
    <div class="w-100 p-35px"></div>
  </div>

  <!-- DAO Coin Info -->
  <div
    class="w-100 d-flex flex-column"
    *ngIf="activeTab == 'DAO Coin' && !loading"
  >
    <div class="w-100 d-flex justify-content-start px-15px fs-15px">
      <div
        class="container border-bottom border-color-grey font-weight-bold fs-20px pl-0px py-15px"
      >
        Holders of ${{ profile.Username }}'s DAO Coin
      </div>
    </div>

    <div>
      <div class="container fs-15px flex-grow-1">
        <div class="row no-gutters border-bottom border-color-grey fc-muted">
          <div class="col-6 d-flex py-15px mb-0">Username or PubKey</div>
          <div class="col-6 py-15px mb-0">Coins Held</div>
        </div>
        <creator-profile-hodlers
          [profile]="profile"
          [isDAOCoin]="true"
        ></creator-profile-hodlers>
      </div>
    </div>
    <div class="w-100 p-35px"></div>
  </div>

  <!-- Diamonds -->
  <div
    class="w-100 d-flex flex-column"
    *ngIf="activeTab == 'Diamonds' && !loading"
  >
    <creator-diamonds [profile]="profile"></creator-diamonds>
    <div class="w-100 p-35px"></div>
  </div>

  <!-- NFTs -->
  <div class="w-100 d-flex flex-column" *ngIf="activeTab == 'NFTs' && !loading">
    <creator-profile-nfts
      [profile]="profile"
      [showProfileAsReserved]="showProfileAsReserved()"
      (blockUser)="userBlocked()"
    ></creator-profile-nfts>
    <div class="w-100 p-35px"></div>
  </div>
</div>
<!-- SPACER FOR BOTTOM BAR ON MOBILE -->
<div class="global__bottom-bar-mobile-height"></div>
